<!-- ChildComponent.vue -->
<template>
  <div>
    <DxPieChart
      :title="titleProp"
      :data-source="dsProp"
      :inner-radius="0.65"
      resolve-label-overlapping="shift"
      size-group="piesGroup"
      type="doughnut"
      center-template="centerTemplate"
      palette="Harmony Light"
      palette-extension-mode="blend"
      @point-click="pointClick"
    >
      >
      <DxSeries :argument-field="argumentFieldProp" value-field="total">
        <DxLabel
          :visible="true"
          :customize-text="customizeLabel"
          position="columns"
        >
          <DxConnector :visible="true" :width="0.5" />
          <DxFont :size="16" />
        </DxLabel>
      </DxSeries>
      <DxLegend
        :visible="true"
        :margin="0"
        horizontal-alignment="center"
        vertical-alignment="bottom"
        :customize-items="customizeLegend"
        hover-mode="allArgumentPoints"
      />
      <template #centerTemplate="data">
        <CenterTemplate :pie-chart="data.data" />
      </template>
      <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip">
        <DxFormat type="millions" />
      </DxTooltip>
    </DxPieChart>
  </div>
</template>

<script>
import {
  DxPieChart,
  DxSeries,
  DxTooltip,
  DxLegend,
  DxLabel,
  DxConnector,
} from "devextreme-vue/pie-chart";
import CenterTemplate from "./CenterTemplate.vue";
import router from "@/router";
export default {
  components: {
    DxPieChart,
    DxSeries,
    DxTooltip,
    DxLegend,
    DxLabel,
    DxConnector,
    CenterTemplate,
  },
  data() {
    return {
      router,
    };
  },
  props: {
    argumentFieldProp: { type: String },
    pointClickProp: { type: String },
    dataGridFilterArgProp: {
      type: String,
      default: "", // Set the default value to null
    },
    // dataGridFilterArgProp: { type: String },
    titleProp: { type: String },
    dsProp: {
      type: [Object, Array],
      required: true,
    },
  },
  methods: {
    pointClick(e) {
      // console.log("pointClick", e);
      // console.log("pointClickProp", this.pointClickProp);
      // console.log("pointClick link", e.target.data[this.pointClickProp]);

      let filterData = e.target.data.filterExp;
      console.log("filterData", filterData);
      const url = this.$router.resolve({
        name: "pegawai-list-custom",
        query: { filter: filterData },
      }).href;
      window.open(url, "_blank");
    },

    // seriesClick(e) {
    //   // console.log("seriesClick", e);
    // },
    customizeLabel(argumentText) {
      // return "";
      // return `${argumentText}\n${valueText}`;
      // console.log("label", argumentText);
      // console.log("customizeLabel", argumentText);
      return `${argumentText.argument} : ${argumentText.valueText} (${argumentText.percentText})`;
    },
    customizeTooltip({ argument, valueText, percent }) {
      return {
        text: `${argument} : ${valueText} (${(percent * 100).toFixed(2)}%)`,
      };
    },
  },
};
</script>
